import React, { useState } from 'react';
import { ChevronLeft, Phone, FileText, MoreVertical, UserPlus } from 'lucide-react';

const MOCK_SUPPLIERS = [
  {
    id: 1,
    name: '李四',
    phone: '138****5678',
    status: 'active',
    totalOrders: 15,
    monthOrders: 3,
    totalWeight: '245吨',
    monthIncome: '12.8万',
    lastDelivery: '2025-02-20',
    verified: true
  },
  {
    id: 2,
    name: '王五',
    phone: '139****1234',
    status: 'active',
    totalOrders: 8,
    monthOrders: 2,
    totalWeight: '156吨',
    monthIncome: '8.2万',
    lastDelivery: '2025-02-18',
    verified: true
  },
  {
    id: 3,
    name: '赵六',
    phone: '137****9876',
    status: 'pending',
    totalOrders: 0,
    monthOrders: 0,
    totalWeight: '0吨',
    monthIncome: '0万',
    lastDelivery: '-',
    verified: false
  }
];

export default function SupplierManagePage({ onBack }) {
  const [activeTab, setActiveTab] = useState('all');

  const filteredSuppliers = activeTab === 'all' 
    ? MOCK_SUPPLIERS 
    : MOCK_SUPPLIERS.filter(s => s.status === activeTab);

  const totalStats = {
    suppliers: MOCK_SUPPLIERS.length,
    activeSuppliers: MOCK_SUPPLIERS.filter(s => s.status === 'active').length,
    monthOrders: MOCK_SUPPLIERS.reduce((sum, s) => sum + s.monthOrders, 0),
    monthAmount: '21.0万'
  };

  return (
    <div className="min-h-full bg-slate-50">
      <div className="bg-gradient-to-br from-blue-500 via-blue-600 to-blue-700 text-white p-4 pt-12 pb-6">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-3">
            <button onClick={onBack} className="p-1">
              <ChevronLeft size={24} />
            </button>
            <h1 className="text-lg font-bold">实供人管理</h1>
          </div>
          <button className="flex items-center gap-1.5 bg-white/20 backdrop-blur-sm px-3 py-1.5 rounded-full text-sm border border-white/30">
            <UserPlus size={14} />
            邀请实供人
          </button>
        </div>
        
        <div className="bg-white/20 backdrop-blur-sm rounded-xl p-4 border border-white/30">
          <div className="grid grid-cols-4 gap-2 text-center">
            <div>
              <div className="text-2xl font-bold">{totalStats.suppliers}</div>
              <div className="text-xs text-white/70">实供人数</div>
            </div>
            <div>
              <div className="text-2xl font-bold">{totalStats.activeSuppliers}</div>
              <div className="text-xs text-white/70">活跃人数</div>
            </div>
            <div>
              <div className="text-2xl font-bold">{totalStats.monthOrders}</div>
              <div className="text-xs text-white/70">本月订单</div>
            </div>
            <div>
              <div className="text-2xl font-bold">{totalStats.monthAmount}</div>
              <div className="text-xs text-white/70">本月交易额</div>
            </div>
          </div>
        </div>
      </div>

      <div className="p-4">
        <div className="flex gap-2 mb-4">
          <button
            onClick={() => setActiveTab('all')}
            className={`px-4 py-2 rounded-full text-sm font-medium transition-all ${
              activeTab === 'all' 
                ? 'bg-blue-500 text-white' 
                : 'bg-white text-slate-600 border border-slate-200'
            }`}
          >
            全部 ({MOCK_SUPPLIERS.length})
          </button>
          <button
            onClick={() => setActiveTab('active')}
            className={`px-4 py-2 rounded-full text-sm font-medium transition-all ${
              activeTab === 'active' 
                ? 'bg-blue-500 text-white' 
                : 'bg-white text-slate-600 border border-slate-200'
            }`}
          >
            活跃 ({MOCK_SUPPLIERS.filter(s => s.status === 'active').length})
          </button>
          <button
            onClick={() => setActiveTab('pending')}
            className={`px-4 py-2 rounded-full text-sm font-medium transition-all ${
              activeTab === 'pending' 
                ? 'bg-blue-500 text-white' 
                : 'bg-white text-slate-600 border border-slate-200'
            }`}
          >
            待激活 ({MOCK_SUPPLIERS.filter(s => s.status === 'pending').length})
          </button>
        </div>

        <div className="space-y-3">
          {filteredSuppliers.map((supplier) => (
            <div key={supplier.id} className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
              <div className="p-4">
                <div className="flex items-start justify-between mb-3">
                  <div className="flex items-center gap-3">
                    <div className="w-12 h-12 bg-gradient-to-br from-blue-400 to-blue-600 rounded-full flex items-center justify-center text-white font-bold text-lg">
                      {supplier.name.charAt(0)}
                    </div>
                    <div>
                      <div className="flex items-center gap-2">
                        <span className="font-medium text-slate-800">{supplier.name}</span>
                        {supplier.verified && (
                          <span className="text-xs text-green-600 bg-green-50 px-1.5 py-0.5 rounded">已实名</span>
                        )}
                        {supplier.status === 'pending' && (
                          <span className="text-xs text-amber-600 bg-amber-50 px-1.5 py-0.5 rounded">待激活</span>
                        )}
                      </div>
                      <div className="flex items-center gap-1 text-xs text-slate-400 mt-1">
                        <Phone size={12} />
                        {supplier.phone}
                      </div>
                    </div>
                  </div>
                  <button className="p-2 text-slate-400 hover:text-slate-600">
                    <MoreVertical size={16} />
                  </button>
                </div>

                {supplier.status === 'active' && (
                  <div className="grid grid-cols-4 gap-2 bg-slate-50 rounded-lg p-3">
                    <div className="text-center">
                      <div className="text-sm font-bold text-slate-800">{supplier.totalOrders}</div>
                      <div className="text-xs text-slate-500">累计订单</div>
                    </div>
                    <div className="text-center">
                      <div className="text-sm font-bold text-slate-800">{supplier.monthOrders}</div>
                      <div className="text-xs text-slate-500">本月订单</div>
                    </div>
                    <div className="text-center">
                      <div className="text-sm font-bold text-slate-800">{supplier.totalWeight}</div>
                      <div className="text-xs text-slate-500">送货总量</div>
                    </div>
                    <div className="text-center">
                      <div className="text-sm font-bold text-red-500">{supplier.monthIncome}</div>
                      <div className="text-xs text-slate-500">本月收入</div>
                    </div>
                  </div>
                )}

                {supplier.status === 'pending' && (
                  <div className="bg-amber-50 border border-amber-200 rounded-lg p-3 flex items-center justify-between">
                    <div className="text-xs text-amber-700">
                      实供人尚未完成实名认证，无法进行交易
                    </div>
                    <button className="text-xs text-amber-600 font-medium">
                      发送提醒
                    </button>
                  </div>
                )}

                <div className="flex items-center justify-between mt-3 text-xs text-slate-400">
                  <span>最近送货：{supplier.lastDelivery}</span>
                  <button className="flex items-center gap-1 text-blue-500 font-medium">
                    <FileText size={12} />
                    查看订单
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-4 bg-white rounded-xl shadow-sm border border-slate-200 p-4">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
              <UserPlus size={18} className="text-blue-600" />
            </div>
            <div>
              <div className="text-sm font-medium text-slate-800">邀请新实供人</div>
              <div className="text-xs text-slate-500">分享邀请码或链接给实供人</div>
            </div>
          </div>
          <div className="bg-slate-50 rounded-lg p-3">
            <div className="flex items-center justify-between">
              <div>
                <div className="text-xs text-slate-500 mb-1">我的邀请码</div>
                <div className="text-lg font-bold text-slate-800 font-mono tracking-wider">FGZTC2025</div>
              </div>
              <button className="bg-blue-500 text-white px-4 py-2 rounded-lg text-sm font-medium">
                复制邀请码
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
